export default __webpack_public_path__ + "static/media/bnr_rect.640b1e15.jpg";